var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "register" },
    [
      _c("div", { staticClass: "clearfix" }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.startContentView,
              expression: "startContentView",
            },
          ],
          staticClass: "row startContent",
        },
        [
          _c("div", { staticClass: "col-12" }, [
            _vm._m(0),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button-sm type-3",
                    on: {
                      click: function ($event) {
                        return _vm.backUrl()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "icon mdi mdi-arrow-left" }),
                    _vm._v("Vissza"),
                  ]
                ),
              ]),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "button button-sm float-right",
                    on: {
                      click: function ($event) {
                        return _vm.goToForm()
                      },
                    },
                  },
                  [_vm._v("Tovább")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.beError && !_vm.startContentView,
              expression: "beError && !startContentView",
            },
          ],
          staticClass: "row",
        },
        [
          _vm.errorsText.length == 0
            ? _c("h3", [_vm._v("Hoops valamilyen hiba történt...")])
            : _c("h3", { staticClass: "mb-3" }, [_vm._v("Hiba történt:")]),
          _vm._v(" "),
          _c("br"),
          _vm._l(_vm.errorsText, function (error) {
            return _c("p", [
              error.hibas == 1
                ? _c("span", {
                    domProps: { innerHTML: _vm._s(error.hiba_szoveg) },
                  })
                : _vm._e(),
            ])
          }),
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSubmitFormSend && !_vm.startContentView,
              expression: "!isSubmitFormSend && !startContentView",
            },
          ],
          staticClass: "row",
        },
        [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("stepper", {
                attrs: {
                  steps: _vm.steps,
                  currentStep: _vm.currentStep,
                  maxStep: _vm.maxCurrentStep,
                },
                on: { selectedStep: _vm.onSelectStep },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep == 0,
                      expression: "currentStep == 0",
                    },
                  ],
                  staticClass: "step ",
                },
                [
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.last_name,
                            expression: "step0.last_name",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.last_name.$error,
                        },
                        attrs: {
                          name: "last_name",
                          type: "text",
                          placeholder: "Vezetéknév*",
                        },
                        domProps: { value: _vm.step0.last_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step0,
                              "last_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.first_name,
                            expression: "step0.first_name",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.first_name.$error,
                        },
                        attrs: {
                          name: "first_name",
                          type: "text",
                          placeholder: "Keresztnév*",
                        },
                        domProps: { value: _vm.step0.first_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step0,
                              "first_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.zip_code,
                            expression: "step0.zip_code",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.zip_code.$error,
                        },
                        attrs: {
                          name: "zip_code",
                          type: "text",
                          placeholder: "Irányítószám*",
                        },
                        domProps: { value: _vm.step0.zip_code },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.step0, "zip_code", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.city,
                            expression: "step0.city",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.city.$error,
                        },
                        attrs: {
                          name: "city",
                          type: "text",
                          placeholder: "Település*",
                        },
                        domProps: { value: _vm.step0.city },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.step0, "city", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.street_name,
                            expression: "step0.street_name",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.street_name.$error,
                        },
                        attrs: {
                          name: "street_name",
                          type: "text",
                          placeholder: "Közterület neve*",
                        },
                        domProps: { value: _vm.step0.street_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step0,
                              "street_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg-6" },
                      [
                        _c("simple-dropdown", {
                          attrs: {
                            dataSource: _vm.streetTypes,
                            displayProp: "title",
                            placeholder: "Közterület jellege*",
                            errorClass: _vm.$v.step0.street_type.$error,
                          },
                          model: {
                            value: _vm.step0.street_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.step0, "street_type", $$v)
                            },
                            expression: "step0.street_type",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.street_number,
                            expression: "step0.street_number",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.street_number.$error,
                        },
                        attrs: {
                          name: "street_number",
                          type: "text",
                          placeholder: "Házszám*",
                        },
                        domProps: { value: _vm.step0.street_number },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step0,
                              "street_number",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.email,
                            expression: "step0.email",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.email.$error,
                        },
                        attrs: {
                          name: "email",
                          type: "text",
                          placeholder: "E-mail cím*",
                        },
                        domProps: { value: _vm.step0.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.step0, "email", $event.target.value)
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step0.phone,
                            expression: "step0.phone",
                          },
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: ["+## ## ### ####", "+## ## ### ###"],
                            expression:
                              "[ '+## ## ### ####', '+## ## ### ###']",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step0.phone.$error,
                        },
                        attrs: {
                          name: "phone",
                          id: "phone",
                          type: "text",
                          placeholder: "Telefonszám*",
                        },
                        domProps: { value: _vm.step0.phone },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.step0, "phone", $event.target.value)
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-sm type-3",
                          on: {
                            click: function ($event) {
                              return _vm.backUrl()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "icon mdi mdi-arrow-left" }),
                          _vm._v("Vissza"),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-sm float-right",
                          on: {
                            click: function ($event) {
                              return _vm.nextStep()
                            },
                          },
                        },
                        [_vm._v("Tovább")]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep == 1,
                      expression: "currentStep == 1",
                    },
                  ],
                  staticClass: "step",
                },
                [
                  _c("p", [_vm._v("Családi ház adatai")]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step1.house_postcode,
                            expression: "step1.house_postcode",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step1.house_postcode.$error,
                        },
                        attrs: {
                          name: "house_postcode",
                          type: "text",
                          placeholder: "Irányítószám*",
                        },
                        domProps: { value: _vm.step1.house_postcode },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step1,
                              "house_postcode",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step1.house_city,
                            expression: "step1.house_city",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error": _vm.$v.step1.house_city.$error,
                        },
                        attrs: {
                          name: "house_city",
                          type: "text",
                          placeholder: "Település*",
                        },
                        domProps: { value: _vm.step1.house_city },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step1,
                              "house_city",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step1.house_street_name,
                            expression: "step1.house_street_name",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error":
                            _vm.$v.step1.house_street_name.$error,
                        },
                        attrs: {
                          name: "house_street_name",
                          type: "text",
                          placeholder: "Közterület neve*",
                        },
                        domProps: { value: _vm.step1.house_street_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step1,
                              "house_street_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg-6" },
                      [
                        _c("simple-dropdown", {
                          attrs: {
                            dataSource: _vm.streetTypes,
                            displayProp: "title",
                            placeholder: "Közterület jellege*",
                            errorClass: _vm.$v.step1.house_street_type.$error,
                          },
                          model: {
                            value: _vm.step1.house_street_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.step1, "house_street_type", $$v)
                            },
                            expression: "step1.house_street_type",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step1.house_street_number,
                            expression: "step1.house_street_number",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error":
                            _vm.$v.step1.house_street_number.$error,
                        },
                        attrs: {
                          name: "house_street_number",
                          type: "text",
                          placeholder: "Házszám*",
                        },
                        domProps: { value: _vm.step1.house_street_number },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step1,
                              "house_street_number",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step1.dealer_company_name,
                            expression: "step1.dealer_company_name",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                          "invalid-error":
                            _vm.$v.step1.dealer_company_name.$error,
                        },
                        attrs: {
                          name: "dealer_company_name",
                          type: "text",
                          placeholder: "Kereskedő cég neve*",
                        },
                        domProps: { value: _vm.step1.dealer_company_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step1,
                              "dealer_company_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            position: "relative",
                            top: "-30px",
                            "font-size": "15px",
                          },
                        },
                        [_vm._v("(a számlán található számla kiállító neve)")]
                      ),
                    ]),
                    _c("div", { staticClass: "col-12 col-sm-6 col-lg-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.step1.implementer_company_name,
                            expression: "step1.implementer_company_name",
                          },
                        ],
                        class: {
                          "form-control": true,
                          "form-input-item": true,
                        },
                        attrs: {
                          name: "implementer_company_name",
                          type: "text",
                          placeholder: "Kivitelező (cég) neve",
                        },
                        domProps: { value: _vm.step1.implementer_company_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.step1,
                              "implementer_company_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-sm type-3",
                          on: {
                            click: function ($event) {
                              return _vm.backStep()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "icon mdi mdi-arrow-left" }),
                          _vm._v("Vissza"),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "col-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button button-sm float-right",
                          on: {
                            click: function ($event) {
                              return _vm.nextStep()
                            },
                          },
                        },
                        [_vm._v("Tovább")]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentStep == 2,
                      expression: "currentStep == 2",
                    },
                  ],
                  staticClass: "step",
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "row mt-2" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-6 col-12" },
                        [
                          _c("p", [_vm._v("Számla feltöltés")]),
                          _c(
                            "file-upload",
                            {
                              ref: "uploadFiles",
                              class: {
                                button: true,
                                "button-sm": true,
                                "invalid-error": _vm.$v.step2.files.$error,
                              },
                              attrs: {
                                inputId: "files",
                                "post-action": "api/ajax-upload-invoice.php",
                                extensions:
                                  "gif,jpg,jpeg,png,webp,pdf,doc,text,docx",
                                accept:
                                  "image/png,image/gif,image/jpeg,image/webp,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                multiple: true,
                              },
                              on: {
                                "input-filter": _vm.inputFilter,
                                "input-file": _vm.inputFile,
                              },
                              model: {
                                value: _vm.step2.files,
                                callback: function ($$v) {
                                  _vm.$set(_vm.step2, "files", $$v)
                                },
                                expression: "step2.files",
                              },
                            },
                            [_vm._v("Feltöltés ")]
                          ),
                          _vm._l(_vm.step2.files, function (file, index) {
                            return _c("div", { key: file.id }, [
                              _c("p", { staticClass: "uploadList" }, [
                                _vm._v(_vm._s(file.name)),
                              ]),
                              _c(
                                "span",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.$refs.uploadFiles.remove(file)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "mdi mdi-close-circle-outline",
                                  }),
                                ]
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        { staticClass: "col-md-6 col-12" },
                        [
                          _c("p", [_vm._v("Családi ház képének feltöltése")]),
                          _c(
                            "file-upload",
                            {
                              ref: "upload",
                              class: {
                                button: true,
                                "button-sm": true,
                                "invalid-error": _vm.$v.step2.images.$error,
                              },
                              attrs: {
                                inputId: "images",
                                "post-action": "api/ajax-upload-picture.php",
                                extensions:
                                  "gif,jpg,jpeg,png,webp,jfif,pjp,pjpeg",
                                accept:
                                  "image/png,image/gif,image/jpeg,image/webp,image/jfif,image/pjp,image/pjpeg",
                                multiple: true,
                              },
                              on: {
                                "input-filter": _vm.inputFilter,
                                "input-file": _vm.inputFile,
                              },
                              model: {
                                value: _vm.step2.images,
                                callback: function ($$v) {
                                  _vm.$set(_vm.step2, "images", $$v)
                                },
                                expression: "step2.images",
                              },
                            },
                            [_vm._v("Feltöltés ")]
                          ),
                          _vm._l(_vm.step2.images, function (file, index) {
                            return _c("div", { key: file.id }, [
                              _c(
                                "div",
                                { staticClass: "td-image-thumb-container" },
                                [
                                  _c("img", {
                                    staticClass: "td-image-thumb",
                                    attrs: { src: _vm.getImageSrc(file) },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "td-image-thumb-close",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.$refs.upload.remove(file)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "mdi mdi-close-circle-outline",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                    ]),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
                        _c("div", { staticClass: "form-check-wrapper" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.step2.accept,
                                  expression: "step2.accept",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                value: "1",
                                name: "accept",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.step2.accept)
                                  ? _vm._i(_vm.step2.accept, "1") > -1
                                  : _vm.step2.accept,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.step2.accept,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "1",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.step2, "accept", $$c)
                                  }
                                },
                              },
                            }),
                            _c("span", {
                              class: {
                                "mdi mdi-name check-span": true,
                                "invalid-error": _vm.$v.step2.accept.$error,
                              },
                            }),
                            _vm._m(1),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
                        _c("div", { staticClass: "form-check-wrapper" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.step2.accept2,
                                  expression: "step2.accept2",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                value: "1",
                                name: "accept2",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.step2.accept2)
                                  ? _vm._i(_vm.step2.accept2, "1") > -1
                                  : _vm.step2.accept2,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.step2.accept2,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "1",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept2",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept2",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.step2, "accept2", $$c)
                                  }
                                },
                              },
                            }),
                            _c("span", {
                              class: {
                                "mdi mdi-name check-span": true,
                                "invalid-error": _vm.$v.step2.accept2.$error,
                              },
                            }),
                            _vm._m(2),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "only-mobile-content mb-3" }),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
                        _c("div", { staticClass: "form-check-wrapper" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.step2.accept3,
                                  expression: "step2.accept3",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                value: "1",
                                name: "accept3",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.step2.accept3)
                                  ? _vm._i(_vm.step2.accept3, "1") > -1
                                  : _vm.step2.accept3,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.step2.accept3,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "1",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept3",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept3",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.step2, "accept3", $$c)
                                  }
                                },
                              },
                            }),
                            _c("span", {
                              class: {
                                "mdi mdi-name check-span": true,
                                "invalid-error": _vm.$v.step2.accept3.$error,
                              },
                            }),
                            _c("span", { staticClass: "checkbox-text" }, [
                              _vm._v(
                                "Hozzájárulok, hogy a Baumit Kft. az adataimat a promóció céljából kezelje. "
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "only-mobile-content mb-3" }),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-sm-12 col-lg-12" }, [
                        _c("div", { staticClass: "form-check-wrapper" }, [
                          _c("label", { staticClass: "form-check-label" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.step2.accept4,
                                  expression: "step2.accept4",
                                },
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                value: "1",
                                name: "accept4",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.step2.accept4)
                                  ? _vm._i(_vm.step2.accept4, "1") > -1
                                  : _vm.step2.accept4,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.step2.accept4,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "1",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept4",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.step2,
                                          "accept4",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(_vm.step2, "accept4", $$c)
                                  }
                                },
                              },
                            }),
                            _c("span", {
                              class: {
                                "mdi mdi-name check-span": true,
                                "invalid-error": _vm.$v.step2.accept4.$error,
                              },
                            }),
                            _c("span", { staticClass: "checkbox-text" }, [
                              _vm._v(
                                "Hozzájárulok, hogy részemre a Baumit Kft. újdonságairól, promócióiról, ajánlatairól e-mailt küldjön."
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "only-mobile-content mb-5" }),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-sm type-3",
                            on: {
                              click: function ($event) {
                                return _vm.backStep()
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "icon mdi mdi-arrow-left" }),
                            _vm._v("Vissza"),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button button-sm float-right",
                            attrs: { disabled: _vm.disabledNextButton },
                            on: {
                              click: function ($event) {
                                return _vm.nextStep()
                              },
                            },
                          },
                          [_vm._v("Tovább")]
                        ),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSubmitFormSend && !_vm.startContentView,
              expression: "isSubmitFormSend && !startContentView",
            },
          ],
          staticClass: "row",
        },
        [_vm._m(3)]
      ),
      _c("simplemodal", {
        attrs: {
          modal_title: _vm.modalData.title,
          modal_content: _vm.modalData.content,
          modal_id: _vm.modalData.key,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("p", [
          _vm._v(
            "A promócióban való részvételhez kérjük adja meg személyes adatait, az épületre vonatkozó információkat, illetve töltse fel a vásárlást igazoló számlát és az épület képeit is."
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-text" }, [
      _vm._v("Elfogadom a "),
      _c(
        "a",
        {
          staticClass: "simple-link",
          attrs: {
            target: "_blank",
            href: "./Baumit_Hoszigetelo_promocio_2025_jatekszabalyzat.pdf",
          },
        },
        [_vm._v("játékszabályzatban")]
      ),
      _vm._v(" foglaltakat."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-text" }, [
      _vm._v("Megértettem és elolvastam az "),
      _c(
        "a",
        {
          staticClass: "simple-link",
          attrs: {
            target: "_blank",
            href: "https://baumit.hu/vallalat/adatkezelesi-tajekoztatok",
          },
        },
        [_vm._v("Adatkezelési tájékoztatót")]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _vm._v("Köszönjük, hogy részt vesz a promóciónkban. "),
        _c("br"),
        _vm._v(
          " A beküldött adatokat munkatársaink hamarosan ellenőrizni fogják és jelentkeznek a megadott e-mail címen."
        ),
      ]),
      _c("p", [
        _vm._v("Ha addig szívesen olvasna többet a Baumit megoldásairól, "),
        _c("a", { attrs: { href: "https://baumit.hu", target: "_blank" } }, [
          _vm._v("kattintson ide"),
        ]),
        _vm._v("."),
      ]),
      _c("p", [_vm._v("Üdvözlettel,"), _c("br"), _vm._v(" Baumit")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }